export default __webpack_public_path__ + "static/media/bra-material-3.12d5d292.webp";